const url = "/api/v1/";
import axios from "axios";

// passes payment object info to backend and returns a secret key to be used for payment processing
export const getPaymentIntent = async (paymentObject) => {

    // create url for getting payment intent
    const getPaymentIntentUrl = url + "marketplace/checkout/website";

    console.log('paymentObject', paymentObject)
  
    return new Promise(async (resolve, reject) => {
      try {
                
        const response = await fetch(getPaymentIntentUrl, {
          method: "POST",
          body: JSON.stringify(paymentObject),
          headers: 
            {   "Firebase-UID": '123456789',
                "Content-Type": "application/json",
                "accept": "application/json"
            },
        });
  
        let json = await response.json();

        console.log('getPaymentIntent response:', json);
  
        if (response.status >= 400 && response.status < 600) {
          throw('error getting payment intent...', response)        
        }
  
        resolve(json);
  
      } catch (e) {
        reject(new Error(e));
        console.log('error: ', e)
      }
    });
  
  };



  export const getPaymentIntentExpressPay = async (paymentObject) => {

    // create url for getting payment intent
    const getPaymentIntentUrl = url + "marketplace/checkout/website/express-pay";

    console.log('paymentObject', paymentObject)
  
    return new Promise(async (resolve, reject) => {
      try {
                
        const response = await fetch(getPaymentIntentUrl, {
          method: "POST",
          body: JSON.stringify(paymentObject),
          headers: 
            {   "Firebase-UID": '123456789',
                "Content-Type": "application/json",
                "accept": "application/json"
            },
        });
  
        let json = await response.json();

        console.log('getPaymentIntentExpressPay response:', json);
  
        if (response.status >= 400 && response.status < 600) {
          throw('error getting payment intent...', response)        
        }
  
        resolve(json);
  
      } catch (e) {
        reject(new Error(e));
        console.log('error: ', e)
      }
    });
  
  };